import { defaultIconProps, IconProps } from './IconProps';

export const IconNodepool: import('react').FC<IconProps> = ({ size, color, strokeWidth = 1.5, ...rest }) => (
  <svg width={size} height={size} viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
    <path
      d="M18.3334 13.5833L17.757 5.22479C17.6665 3.91253 17.6212 3.2564 17.3368 2.75902C17.0864 2.32111 16.7094 1.9692 16.2553 1.74952C15.7395 1.5 15.0818 1.5 13.7664 1.5H6.23372C4.91834 1.5 4.26065 1.5 3.74488 1.74952C3.29078 1.9692 2.91376 2.32111 2.66336 2.75902C2.37895 3.2564 2.3337 3.91253 2.2432 5.22479L1.66675 13.5833M18.3334 13.5833C18.3334 15.1942 17.0276 16.5 15.4167 16.5H4.58342C2.97258 16.5 1.66675 15.1942 1.66675 13.5833M18.3334 13.5833C18.3334 11.9725 17.0276 10.6667 15.4167 10.6667H4.58341C2.97258 10.6667 1.66675 11.9725 1.66675 13.5833M5.00008 13.5833H5.00842M10.0001 13.5833H15.0001"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

IconNodepool.defaultProps = defaultIconProps;
